import { render } from "./AdsetNameBlock.vue?vue&type=template&id=6bf80a34"
import script from "./AdsetNameBlock.vue?vue&type=script&lang=js"
export * from "./AdsetNameBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/AdsetNameBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6bf80a34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6bf80a34', __exports__)) {
    api.reload('6bf80a34', __exports__)
  }
  
  module.hot.accept("./AdsetNameBlock.vue?vue&type=template&id=6bf80a34", () => {
    api.rerender('6bf80a34', render)
  })

}


export default __exports__